<div class="section-heading">
  <div class="section-heading__nav-target" [id]="id"></div>
  <h5 class="section-heading__title">
    {{ title }}
  </h5>
  <h6 class="section-heading__description">
    {{ description }}
  </h6>
</div>
